import { StatusColor } from "~/constants/status"

export type StockOutInformationType = {
  skuId: string
  stockoutDates: Date[]
  safetyStockOutDate: Date | undefined
  buffer: number
  status: StockStatus
  stockOutPeriods: [number, number | undefined][]
  suggestedOrder: number | undefined
}

export type StockStatus =
  | "fine"
  | "reorder"
  | "partialStockout"
  | "stockout"
  | "overstock"
  | "noStatus"

export function stockStatusText(status?: StockStatus): string {
  switch (status) {
    case "fine":
      return "All fine"
    case "reorder":
      return "Reorder now"
    case "stockout":
      return "Out of stock"
    case "partialStockout":
      return "Partially out of stock"
    case "overstock":
      return "Overstocked"
    default:
      return "No status"
  }
}

export function stockStatusColor(status?: StockStatus | string) {
  switch (status) {
    case "fine":
      return StatusColor.Success
    case "reorder":
      return StatusColor.Warning
    case "partialStockout":
      return StatusColor.Error
    case "stockout":
      return StatusColor.Error
    case "overstock":
      return StatusColor.Information
    default:
      return StatusColor.Neutral
  }
}

export function calculateStockStatusOnAggregatedLevel(stockStatuses: StockStatus[]): StockStatus {
  if (stockStatuses.every((status) => status === "noStatus")) {
    return "noStatus"
  } else if (stockStatuses.every((status) => status === "stockout")) {
    return "stockout"
  } else if (stockStatuses.some((status) => status === "stockout")) {
    return "partialStockout"
  } else if (stockStatuses.includes("reorder")) {
    return "reorder"
  } else if (stockStatuses.includes("overstock")) {
    return "overstock"
  }

  return "fine"
}
